import { RootState } from '..';

export const projectSelector = (state: RootState) => state.project;

export const projectsListSelector = (state: RootState) => state.project.list;

export const projectsPaginationSelector = (state: RootState) => state.project.pagination;

export const projectsOptionsSelector = (state: RootState) => state.project.options;
